import { render, staticRenderFns } from "./genView.vue?vue&type=template&id=3f9f4eac&scoped=true&"
import script from "./genView.vue?vue&type=script&lang=ts&"
export * from "./genView.vue?vue&type=script&lang=ts&"
import style0 from "./genView.vue?vue&type=style&index=0&id=3f9f4eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9f4eac",
  null
  
)

export default component.exports